export default "__VITE_ASSET__DJnrvDiX__"